import React, { Component } from "react";
import {
  formatDateTimeWithoutSeconds,
  formatTimeWithoutSeconds,
} from "../../../../shared/dateTimeUtils";
import "./CervicalExams.scss";

const CervicalExamDateTime = ({ expanded, time }) => {
  const datetime = expanded
    ? formatDateTimeWithoutSeconds(time)
    : formatTimeWithoutSeconds(time);
  return <div className="time">{datetime}</div>;
};

const CervicalExamValue = ({ exam }) => {
  const values = `${exam.dilatation || "-"}/${exam.effacement || "-"}/${
    exam.station || "-"
  }`;
  return <span className="value">{values}</span>;
};

export default class CervicalExams extends Component {
  render() {
    return (
      <div className="cervical-exams component">
        {this.props.model.list.map((exam) => (
          <div className="exam" key={exam.time}>
            <div className="wrapper">
              <CervicalExamDateTime
                expanded={this.props.expanded}
                time={exam.time}
              />
              <CervicalExamValue exam={exam} />
            </div>
          </div>
        ))}
      </div>
    );
  }
}
